import { graphql } from "./generated/gql";

export const ReportGroupsQuery = graphql(`
  query ReportGroups($termId: ID!) {
    reportGroups(termId: $termId) {
      reportGroupId
      termId
      name
      reportSettingJson
    }
  }
`);

export const ReportQuestionCandidatesQuery = graphql(`
  query ReportQuestionCandidates($termId: ID!) {
    reportQuestionCandidates(termId: $termId) {
      questionId
      name
    }
  }
`);

export const CreateReportGroupMutation = graphql(`
  mutation CreateReportGroup($input: CreateReportGroupInput!) {
    createReportGroup(input: $input) {
      reportGroupId
      name
      reportSettingJson
    }
  }
`);

export const UpdateReportGroupMutation = graphql(`
  mutation UpdateReportGroup($input: UpdateReportGroupInput!) {
    updateReportGroup(input: $input) {
      reportGroupId
      name
      reportSettingJson
    }
  }
`);

export const GenerateReportGroupReportsMutation = graphql(`
  mutation GenerateReportGroupReports($reportGroupId: ID!) {
    generateReportGroupReports(reportGroupId: $reportGroupId)
  }
`);
